export default "__VITE_ASSET__SLWLGPeZ__"